<template>
  <div id="nav-template" class="sticky-top">
    <nav>
        <div class="brand-text">
            <router-link :to="{ path: '/'}">
                Apollo Protocol
                <span class="version-tag">Alpha.v0.1 - Nebulas</span>
            </router-link>
        </div>
        <span class="brand-subtext">
            "Your Framework for Digital Assets on Blockchain"
        </span>

        <div class="card-counter">
            <span v-if="!cardCounterLoading">
                {{ registeredTokens }}
            </span>
            <span v-else>
                {{ 'LOADING' | translate }}
            </span>
            Registered Tokens
        </div>
        <div v-if="pendingTransaction" class="transaction-loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            <sub>{{ 'PENDING_TRANSACTION' | translate }}</sub>
        </div>
        <!--
        <div class="nav-menu">
            <b-button-group class="translation-button" size="sm">
                <b-button :class="{ selected: locale == 'en' }" @click="updateLocale('en')">EN</b-button>
                <b-button :class="{ selected: locale == 'cn' }" @click="updateLocale('cn')">CN</b-button>
            </b-button-group>
            <b-dropdown id="ddown1" :text="$t('ACCOUNT')" right class="btn">
                <b-dropdown-header v-if="user.address" class="address-header">
                    {{ user.address }}
                    <i @click="resetAddress" class="fas fa-trash-alt"></i>
                </b-dropdown-header>
                <b-dropdown-header v-else class="address-header">
                    <div v-if="!userLoading" class="row no-gutters">
                        <div class="col-10">
                             <input type="text" class="form-control" v-model="address" placeholder="Please add your address">
                        </div>
                        <div class="col-2">
                            <button @click="saveAddress" class="btn btn-primary">{{ 'SAVE' | translate }}</button>
                        </div>
                    </div>
                    <div v-else class="row no-gutters">
                        <div class="col-12">
                             {{ 'USER_LOADING' | translate }}
                        </div>
                    </div>
                </b-dropdown-header>
                <b-dropdown-header class="sub-header">
                    <div class="row">
                        <div class="col">
                            {{ 'TOKENS_HEADER' | translate }}: {{ user.tokens }}
                        </div>
                        <div class="col">
                            {{ 'BATTLE_CARDS' | translate }}: {{ cards.length }}
                        </div>
                    </div>
                </b-dropdown-header>

                <div v-if="cards.length > 0" class="stats-container">
                    <div class="row">
                        <div class="col">
                            <header>{{ 'WINS' | translate }}</header>
                            <div>{{ user.winCount }}</div>
                        </div>
                        <div class="col">
                                <header>{{ 'LOSSES' | translate }}</header>
                            <div>{{ user.lossCount }}</div>
                        </div>
                    </div>
                </div>

                <div class="dropdown-menu-body" :class="{ scroll : cards.length >= 8 }">
                    <b-dropdown-item v-for="(card, index) in cards" :key="index" :class="{ 'new-item' : card.new }" @click="viewCard(card)" >
                        <div class="row">
                            <div class="col-sm-5">
                                {{ 'CARD_ONLY' | translate }}: {{ card.name }}
                            </div>
                            <div class="col-sm-3">
                                {{ 'LEVEL' | translate }}: {{ card.level }}

                                <i v-if="card.levelUp" class="far fa-arrow-alt-circle-up level-up"></i>
                            </div>
                            <div class="col-sm-4">
                                {{ 'TOTAL' | translate }}: {{ getCardScore(card) }}
                            </div>
                        </div>

                        <div v-if="card.new" class="new-item-tag">{{ 'NEW' | translate }}</div>
                    </b-dropdown-item>
                </div>

                <div v-if="cards.length <= 0" class="no-content">
                     <span v-if="cardLoading">
                        {{ 'CARDS_LOADING' | translate }}
                    </span>
                    <span v-else>
                        {{ 'NO_CARDS' | translate }}
                    </span>
                </div>
            </b-dropdown>
        </div>
        -->
    </nav>
    <div v-if="hasError.status" class="alert alert-warning" role="alert">
        <div v-html="$t('NEBULAS_ERROR')"></div>
        <div>
            {{ 'ERROR_MESSAGE' | translate }}: {{ hasError.message }}
        </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { getCardScore } from "../../util/transformDna";

export default {
    name: 'the-top-nav',
    methods: {
        viewCard (card) {
            this.$root.$emit('bv::show::modal','card-view-modal');
            this.$store.commit('setCard', card);
        },
        constructCardFromDna (card) {
            let power = {};
            return power;
        },
        getCardScore (card) {
            return getCardScore(card);
        },
        saveAddress () {
            this.$store.commit('setUser', { address: this.address });
            this.$store.commit('updateUserCards', { address: this.address });
        },
        resetAddress () {
            this.$store.commit('resetUser');
            this.$store.commit('resetUserCards');
        },
        updateLocale (locale) {
            
            this.$store.commit('setLocale', { locale });
            
            // Set in module
            this.$i18n.set(locale);

        }
    },
    data () {
        return {
            address: null
        }
    },
    computed: {
        ...mapGetters({
            registeredTokens: 'getRegisteredTokens',

            ///
            user: 'getUser',
            cards: 'getCards',
            locale: 'getLocale',
            account: 'getAccount',
            hasError: 'getHasError',
            userLoading: 'getUserLoading',
            cardLoading: 'getCardLoading',
            cardsCreated: 'getCardsCreated',
            hasExtension: 'getHasExtension',
            pendingTransaction: 'getPendingTransaction',
            cardCounterLoading: 'getCardCounterLoading'
        })
    }
}
</script>

<style scoped lang="less">
@backgroundColor: #3c3f44;
@navFontFamily: 'Orbitron', sans-serif;

.alert {
    text-align: center;
    margin-bottom: 0;
    border-radius: 0;
}

nav {
    .transaction-loader {
        position: absolute;
        top: 55px; left: 26px;

        sub {
            font-size: 13px;
            color: #ccc;
        }
    }

    .form-control {
        border-radius: 0;
    }

    .address-header {
        width: 400px;
        position: relative;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;

        i {
            position: absolute;
            top: 8px;
            right: 10px;
        }
    }

    .brand-text {
        font-size: 24px;
        font-family: @navFontFamily;

        a {
            position: relative;
            color: #fff;

            &:hover {
                text-decoration: none;
            }
        }

        .version-tag {
            position: absolute;
            right: 0; top: -20px;
            font-size: 12px;
            color: #ccc;
        }
    }

    .brand-subtext {
        font-style: italic;
        font-size: 13px;
    }

    .card-counter {
        position: absolute;
        top: 25px;
        left: 30px;
        color: #ccc;
        font-size: 13px;
    }

    .version-text {
        position: absolute;
        top: 15px; right: 30px;
    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    .card-counter, .transaction-loader {
        display: none;
    }
    .dropdown, .translation-button {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheTopNav.vue